export const primary = {
    main: '#6633CC',
    25: '#f8f2fd',
    50: '#EDE7F9',
    100: '#D1C2F0',
    200: '#B399E6',
    300: '#9470DB',
    400: '#7D52D4',
    500: '#6633CC',
    600: '#5E2EC7',
    700: '#5327C0',
    800: '#4920B9',
    900: '#3814AD',
    A100: '#E6E0FF',
    A200: '#BDADFF',
    A400: '#947AFF',
    A700: '#7F60FF',
};
export const secondary = {
    main: '#34AAD4',
    50: '#EDF8FF',
    100: '#D6F1FC',
    200: '#ACE3F7',
    300: '#83D7F4',
    400: '#55C5EC',
    500: '#2EAFDC',
    600: '#1E95C3',
    700: '#0F7FAE',
    800: '#0D6A95',
    900: '#095782',
    A100: '#E0F3FF',
    A200: '#ADDFFF',
    A400: '#7ACBFF',
    A700: '#61C1FF',
};
export const grey = {
    main: '#999999',
    0: '#ffffff',
    50: '#fcfcfc',
    100: '#f9f9f9',
    200: '#e5e5e5',
    300: '#dcdcdc',
    400: '#b8b8b8',
    500: '#999999',
    600: '#707070',
    700: '#5d5d5d',
    800: '#3e3e3e',
    850: '#262626',
    900: '#1d1d1d',
};

export const error = {
    main: '#ea5555',
    25: '#ffe7e7',
    50: '#fad3d3',
    100: '#f5bfbf',
    200: '#f1abab',
    300: '#ec9797',
    400: '#e78484',
    500: '#e27070',
    600: '#de5c5c',
    700: '#d94848',
    800: '#d43434',
    900: '#c42929',
};

export const warning = {
    main: '#f5d63d',
    25: '#fdfade',
    50: '#f1ecc7',
    100: '#e5ddb0',
    200: '#d9cf99',
    300: '#cdc182',
    400: '#c0b26c',
    500: '#b4a455',
    600: '#a8963e',
    700: '#9c8727',
    800: '#907910',
    900: '#7e6c0c',
};

export const ERROR_COLORS = {
    border: '#ea5555',
    background: '#ffe7e7',
    content: '#d43434',
};

export const WARNING_COLORS = {
    border: '#f5d63d',
    background: '#fdfade',
    content: '#907910',
};
